'use client';

import { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';

import '../app/Homepage.css';

import Image from 'next/image';
import SvgIcons from '../components/SvgIcons';
import newfoot from './images/newlogofoot.png';
import logo from './images/foot.png';

const Footer = () => {
  const storeid: number = 2;

  const [formValues, setFormValues] = useState({
    newsemail: '',
    newsemailError: false,
    formloading: false,
    buttonState: 'normal', // Added buttonState to manage button states
  });

  const handleClick = () => {
    if (formValues.newsemail === '') {
      setFormValues((prevValues) => ({
        ...prevValues,
        newsemailError: true,
      }));
      return;
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      buttonState: 'loading',
    }));
    setTimeout(() => {
      setFormValues((prevValues) => ({
        ...prevValues,
        buttonState: 'success',
      }));
      setTimeout(() => {
        setFormValues((prevValues) => ({
          ...prevValues,
          buttonState: 'normal',
        }));
      }, 1000); // Revert to normal after 1 second
    }, 1000); // Show loading for 1 second
    handleSubmit({ preventDefault: () => {} }); // Trigger form submission
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    var error = false;

    if (formValues.newsemail == '') {
      handleChange({
        target: {
          value: true,
          name: 'newsemailError',
        },
      });

      error = true;
    } else {
      handleChange({
        target: {
          value: false,
          name: 'newsemailError',
        },
      });
    }

    if (error) return;
    // Handle form submission logic here
    // Example: Logging form data
    console.log(formValues);

    handleChange({
      target: {
        value: true,
        name: 'formloading',
      },
    });
    var formdata = {
      email: formValues.newsemail,
    };
  console.log("formdata",formdata)
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const notify = () =>
    toast.success('Newsletter subscribed successfully.', {
      style: {
        border: '1px solid #00b852',
        padding: '16px',
        color: '#00b852',
      },
      iconTheme: {
        primary: '#00b852',
        secondary: '#FFFAEE',
      },
    });

  const notifyerror = (msg) =>
    toast.error(msg, {
      style: {
        border: '1px solid #cc0000',
        padding: '16px',
        color: '#cc0000',
      },
      iconTheme: {
        primary: '#cc0000',
        secondary: '#FFFAEE',
      },
    });

  return (
    <>
      <Toaster /> {/* Added Toaster component for toast notifications */}
      <div className=" container mx-auto py-4">
        <hr className='reserve_hr' />
        <div className="!flex md:!flex-row !flex-col !py-[20px]">
          <div className="md:!w-8/12 !w-12/12 md:!text-start !text-center">
            <div className="home_res_right" style={{fontFamily: 'Neue Montreal !important'}}>
              <p>© Copyright  {new Date().getFullYear()} All right reserved by Cleanflowsystems | Powered by ⚡ <a href="https://www.vilvabusiness.com/ecomsaas" target="_blank" rel="noopener noreferrer">Vilva | Your Technology Partner</a>
              </p>
              <div className="privacy_terms">
                <a href="/">Privacy Policy</a>
                <a href="/">Terms & Conditions</a>
              </div>
            </div>
          </div>
          <div className="">
            <div className="reserve_sub ">
              <h2 className='whitespace-nowrap'>Get New Updates!</h2>
              <div className="!rounded-[12px] w-fit md:mx-start mx-auto !p-[2px] !border !flex "
                style={{ boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)' }}>
                <input
                  type="text"
                  className="!pl-3 placeholder:text-[14px] !rounded-[10px]"
                  placeholder="your-email@mail.com"
                  name="newsemail"
                  value={formValues.newsemail}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="!bg-[#FF8B03] !text-white !p-[10px] !rounded-[10px] flex items-center justify-center min-w-[80px] !whitespace-nowrap"
                  onClick={handleClick}
                >
                  {formValues.buttonState === 'loading' ? (
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  ) : formValues.buttonState === 'success' ? (
                    <svg
                      className="h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    'Join Now'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_all">
        <div className="flex flex-wrap container fooot mx-auto">
          <div className="w-full md:w-1/3 p-3 foot_lef">
            <div className="fooot_logo">
              <Image src={newfoot} alt="Clean Logo" priority />
            </div>
            <p className='md:!text-[18px] !text-[14px] !font-medium'>We delivers advanced solutions for the cleanroom and micro contamination industries, offering equipment, apparel, supplies, and services including construction, certification, training, and decontamination.</p>
            <div className="social_foot">
              <a aria-label='footer facebook icon of clean flow ' href="https://www.facebook.com/profile.php?id=100070193553673" target='_blank'>
                <SvgIcons.FootFace />
              </a>
              <a  aria-label='footer Instagram icon of clean flow 'href="https://www.instagram.com/cleanflow_systems/" target='_blank'>
                <SvgIcons.FootIn />
              </a>
              
              {/* <SvgIcons.FootYou /> */}
              {/* <SvgIcons.FootX /> */}
            </div>
          </div>
          <div className="w-full md:w-1/6 p-3">
            <ul>
              <li><a href="/" className='md:!text-[18px] !text-[14px] !font-medium'>Home</a></li>
              <li><a href="/products" className='md:!text-[18px] !text-[14px] !font-medium'>Products</a></li>
              <li><a href="/services" className='md:!text-[18px] !text-[14px] !font-medium'>Services</a></li>
              <li><a href="/about-us" className='md:!text-[18px] !text-[14px] !font-medium'>About</a></li>
            </ul>
          </div>
          <div className="w-full md:w-1/6 p-3">
            <ul>
              <li><a href="/contact-us" className='md:!text-[18px] !text-[14px] !font-medium'>Contact</a></li>
              <li><a href="/cleanroom-blog" className='md:!text-[18px] !text-[14px] !font-medium'>Blog</a></li>
              <li><a href="/gallery" className='md:!text-[18px] !text-[14px] !font-medium'>Gallery</a></li>
              <li><a href="/sitemap" className='md:!text-[18px] !text-[14px] !font-medium'>Sitemap</a></li>
            </ul>
          </div>
          <div className="w-full md:w-1/3 p-3">
            <div className="foot_right">
              <div className="right_icons_all">
                <div className="right_icons">
                  <SvgIcons.FootCall />
                </div>
                <p className='md:!text-[18px] !text-[14px] !font-medium'><a href="tel:+91 78100 06665" className='md:!text-[18px] !text-[14px] !font-medium'>+91 78100 06665</a></p>
              </div>
              <div className="right_icons_all">
                <div className="right_icons">
                  <SvgIcons.FootMail />
                </div>
                <p className='md:!text-[18px] !text-[14px] !font-medium'><a href="mailto:cleanflowsystems@gmail.com" className='md:!text-[18px] !text-[14px] !font-medium'>cleanflowsystems@gmail.com</a></p>
              </div>
              <div className="right_icons_all " style={{display: 'flex', alignItems: 'start !important'}}>
                <div className="right_icons flext">
                  <SvgIcons.FootLocation />
                </div>
                <p className='md:!text-[18px] !text-[14px] !font-medium'><a href="#" className='md:!text-[18px] !text-[14px] !font-medium'>14, Muthamizh Street, Chelli Nagar Main Road, Selaiyur, Chennai - 600 073.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
